import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { individualPausesService, PauseIndividualRequest } from '@aslanpay/portal-common-lib';

const usePauseIndividual = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, PauseIndividualRequest>) => {
  return useMutation<unknown, Error, PauseIndividualRequest>(
    ({ id, reason, comment }: PauseIndividualRequest) =>
      individualPausesService.pauseIndividual({
        id,
        reason,
        comment,
      }),
    { onSuccess, onError }
  );
};

export default usePauseIndividual;
